import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild, inject, signal } from '@angular/core';
import { KnowledgeService } from '../../../core/services/knowledge.service';
import privacyDocuments from './privacy-documents.json';

@Component({
  selector: 'app-datenschutz-modal',
  standalone: true,
  templateUrl: './datenschutz-modal.component.html',
  styleUrl: '../impressum-modal/impressum-modal.component.scss',
  styles: `
    dialog { padding: 0; color: var(--color-text-primary); }
    dialog::backdrop { background: var(--color-overlay-backdrop); }
    .impressum-body { line-height: var(--line-height-relaxed); }
    .impressum-body a { color: var(--color-brand-primary-hover); }
    .privacy-download { display: inline-block; padding: var(--space-3); border: 1px solid currentColor; border-radius: var(--radius-sm); font-weight: 700; }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatenschutzModalComponent implements AfterViewInit {
  @Input() standortClz = '';
  readonly privacyUrl = signal<string | null>(null);
  readonly sectionTitles = ['Information über die Verarbeitung personenbezogener Daten', 'Ihre Rechte', 'Widerspruch oder Widerruf gegen die Verarbeitung Ihrer Daten'];
  private readonly knowledge = inject(KnowledgeService);
  @ViewChild('dialog', { static: true }) private dialog!: ElementRef<HTMLDialogElement>;
  @Output() close = new EventEmitter<void>();

  get privacyDocument(): readonly string[] | null {
    if (this.standortClz === '413' || this.standortClz === '429') return null;
    return Object.hasOwn(privacyDocuments, this.standortClz)
      ? (privacyDocuments as Record<string, string[]>)[this.standortClz] : privacyDocuments['225'];
  }

  ngAfterViewInit(): void {
    this.dialog.nativeElement.showModal();
    if (this.standortClz === '') return;
    this.knowledge.getPrivacyUrl(this.standortClz).subscribe({ next: url => this.privacyUrl.set(url), error: () => this.privacyUrl.set(null) });
  }

  onClose(): void {
    this.dialog.nativeElement.close();
    this.close.emit();
  }
}
